import { Badge, Box, Indicator, Text } from '@mantine/core';
import React from 'react';

import { useUnresolvedTicketsCount } from '@portals/api/partners';

export const TicketsCounter = () => {
  const unresolvedTicketsCount = useUnresolvedTicketsCount();

  return unresolvedTicketsCount.data ? (
    <Badge color="blue" radius="xl" size="sm" px="xs" variant="filled">
      {unresolvedTicketsCount.data}
    </Badge>
  ) : null;
};

export function TicketsIndicator({ children }: { children: React.ReactNode }) {
  const unresolvedTicketsCount = useUnresolvedTicketsCount();

  if (!unresolvedTicketsCount.data) return <>{children}</>;

  return (
    <Indicator
      label={
        <Box>
          <Text>{unresolvedTicketsCount.data}</Text>
        </Box>
      }
      color="blue"
      inline
      size={20}
      offset={-5}
    >
      {children}
    </Indicator>
  );
}
